import React, { useState, useMemo, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { TbFlag3, TbLayoutDashboardFilled, TbTruckDelivery } from "react-icons/tb";
import { MdApproval, MdFeedback, MdGroups, MdLocalOffer, MdOutlinePointOfSale, MdOutlineVerifiedUser } from "react-icons/md";
import { FaChartLine, FaCommentDots, FaComments, FaFolderPlus, FaHouseUser, FaProductHunt, FaSitemap, FaStore, FaTags, FaUserCheck, FaUserLarge, FaUserPlus, FaUserTag } from "react-icons/fa6";
import { RiAdvertisementLine, RiShoppingBag3Fill } from "react-icons/ri";
import { IoCard, IoChatbubbles, IoCheckmarkDoneSharp } from "react-icons/io5";
import { IoIosLogOut } from "react-icons/io";
import { AiFillCaretDown, AiFillCaretUp, AiOutlineFolderView } from "react-icons/ai";
import { FaUsers, FaUserTie, FaUserShield, FaPlusCircle, FaRegListAlt, FaUserCircle, FaBullhorn, FaGift, FaCreditCard, FaUniversity, FaUnity } from "react-icons/fa";
import { HiOutlineBadgeCheck, HiOutlineDocumentReport } from "react-icons/hi";
import { MdOutlineGroup } from "react-icons/md";
import { MdAttribution } from "react-icons/md";
import { PiUsersThreeFill } from "react-icons/pi";
import { SiGithubsponsors } from "react-icons/si";
import { useAuth } from "../../../context/AuthContext";
import { MdOutlineBrandingWatermark } from "react-icons/md";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { BiMessageDetail } from "react-icons/bi";

const menuItems = [
  {
    label: "Dashboard",
    path: "/admin",
    icon: <TbLayoutDashboardFilled />,
    exact: true, // Only active when the location is exactly "/admin"
  },
  {
    label: "Orders",
    icon: <IoCard />,
    submenu: [
      {
        label: "Orders View",
        path: "/admin/orders/view_orders",
        icon: <AiOutlineFolderView />,
      },
    ],
  },
  {
    label: "Sales",
    path: "/admin/sales",
    icon: <FaChartLine />,
  },
  {
    label: "Report",
    icon: <TbFlag3 />,
    submenu: [
      {
        label: "Report Overall",
        path: "/admin/report/overall",
        icon: <HiOutlineDocumentReport />,
      },
      { label: "Sales Report", path: "/admin/report/sales", icon: <MdOutlinePointOfSale /> },
      {
        label: "Delivery Report",
        path: "/admin/report/delivery",
        icon: <TbTruckDelivery />,
      },
      {
        label: "Order Report",
        path: "/admin/report/orders",
        icon: <IoCard />,
      },
    ],
  },
  {
    label: "Sellers",
    path: "/admin/sellers",
    icon: <MdGroups />,
  },
  {
    label: "Sub Admins",
    icon: <FaUserTie />,
    submenu: [
      {
        label: "Sub Admin List",
        path: "/admin/subadmins",
        icon: <FaRegListAlt />,
      },
      // You can add more sub-admin related links here later
    ],
  },
  {
    label: "Customers",
    path: "/admin/customers",
    icon: <FaUserLarge />,
  },
  {
    label: "Admin Allocation",
    icon: <FaUserShield />,
    submenu: [
      {
        label: "Customer Allocation",
        path: "allocation/customer",
        icon: <FaHouseUser />,
      },
      {
        label: "Seller Allocation",
        path: "allocation/seller",
        icon: <MdOutlineVerifiedUser />,
      },
    ],
  },
  {
    label: "Approval",
    icon: <HiOutlineBadgeCheck />,
    submenu: [
      {
        label: "Seller Approval",
        path: "/admin/approval/seller",
        icon: <FaUserCheck />,
      },
      {
        label: "Brand Approval",
        path: "/admin/approval/brands",
        icon: <MdApproval />,
      },
      {
        label: "Product Approval",
        path: "/admin/approval/products",
        icon: <FaProductHunt />,
      },
      {
        label: "Offer Approval",
        path: "/admin/approval/offer",
        icon: <MdLocalOffer />,
      },
      {
        label: "Banner Approval",
        path: "/admin/approval/banner",
        icon: <RiAdvertisementLine />,
      },
      {
        label: "Sponsor Approval",
        path: "/admin/approval/sponsor",
        icon: <SiGithubsponsors />,
      },
    ],
  },
  {
    label: "Create & Manage",
    icon: <FaPlusCircle />,
    submenu: [
      {
        label: "Create Item",
        path: "/admin/create/item",
        icon: <FaRegListAlt />,
      },
      {
        label: "Create Unit",
        path: "/admin/create/unit",
        icon: <FaUnity />,
      },
      {
        label: "Create Category",
        path: "/admin/list/category",
        icon: <FaFolderPlus />,
      },
      {
        label: "Create Sub Category",
        path: "/admin/list/subcategory",
        icon: <FaSitemap />,
      },
      {
        label: "Create Sub Admin",
        path: "/admin/create/subadmin",
        icon: <FaUserPlus />,
      },
      {
        label: "Create Seller",
        path: "/admin/create/seller",
        icon: <FaUserPlus />,
      },
      {
        label: "Create Brand",
        path: "/admin/create/brand",
        icon: <MdOutlineBrandingWatermark />,
      },
      {
        label: "Create Banner",
        path: "/admin/create/banner",
        icon: <MdOutlineLibraryAdd />,
      },
    ],
  },
  {
    label: "Add Packages",
    icon: <IoChatbubbles />,
    submenu: [
      {
        label: "Banner",
        // icon: <MdFeedback />,
        path: "/admin/packages/banner",
      },
      {
        label: "Sponsor",
        // icon: <FaUserTag />,
        path: "/admin/packages/sponsor",
      }
      ,
      {
        label: "Special Offer",
        // icon: <FaComments />,
        path: "/admin/packages/specialoffer",
      },
    ],
  },
  {
    label: "Admin Offers",
    icon: <FaTags />,
    submenu: [
      {
        label: "Bank",
        path: "/admin/offers/bank",
        icon: <FaUniversity />, // Represents banks and financial institutions
      },
      {
        label: "EMI Options",
        path: "/admin/offers/emi",
        icon: <FaCreditCard />, // Represents EMI and credit payments
      },
      {
        label: "Rewards",
        path: "/admin/offers/rewards",
        icon: <FaGift />, // Represents reward programs and incentives
      },
      {
        label: "Advertisement",
        path: "/admin/offers/advertisement",
        icon: <FaBullhorn />, // Represents ads and promotions
      },
    ],
  },

  {
    label: "Revenue & Income",
    path: "/admin/revenueandincome",
    icon: <FaPlusCircle />,
    submenu: [
      {
        label: "Revenue",
        path: "/admin/revenue",
        icon: <FaRegListAlt />,
      },
      {
        label: "Order Commission",
        path: "/admin/ordercommission",
        icon: <FaSitemap />,
      },
      {
        label: "Promotion Revenue",
        path: "/admin/promotionrevenue",
        icon: <FaSitemap />,
      },
      {
        label: "Seller Payout",
        path: "/admin/sellerpayout",
        icon: <FaSitemap />,
      },
      {
        label: "Subadmin Payout",
        path: "/admin/subadminpayout",
        icon: <FaSitemap />
      }
      // {
      //   label: "Offer Income",
      //   path: "/admin/offerincome",
      //   icon: <FaUserPlus />,
      // },
      // {
      //   label: "Sponsor Income",
      //   path: "/admin/sponsorincome",
      //   icon: <FaUserPlus />,
      // },
    ],
  },
  {
    label: "Statements",
    path: "/admin/statements",
    icon: <FaTags />,
  },
  {
    label: "Feedbacks",
    icon: <IoChatbubbles />,
    submenu: [
      {
        label: "App Feedback",
        icon: <MdFeedback />,
        submenu: [
          {
            label: "All",
            path: "/admin/feedbacks/app/all",
            icon: <BiMessageDetail />,
          },
          {
            label: "Seller",
            path: "/admin/feedbacks/app/seller",
            icon: <FaStore />,
          },
          {
            label: "Customer",
            path: "/admin/feedbacks/app/customer",
            icon: <FaUserCircle />,
          },
        ],
      },
      {
        label: "Product Feedback",
        path: "/admin/feedbacks/product",
        icon: <FaComments />,
      },
    ],
  },
];

// Updated active check that respects the 'exact' property
const checkItemActive = (item, currentPath) => {
  if (item.path) {
    if (item.exact) {
      if (currentPath === item.path) {
        return true;
      }
    } else {
      if (currentPath.startsWith(item.path)) {
        return true;
      }
    }
  }
  if (item.submenu) {
    return item.submenu.some((subItem) => checkItemActive(subItem, currentPath));
  }
  return false;
};

// Recursive function to get all active paths for a given location
const getActivePaths = (items, currentPath, parentPath = "") => {
  let activePaths = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const currentKeyPath = parentPath ? `${parentPath}-${i}` : `${i}`;

    if (item.path) {
      // Use exact match if 'exact' flag is present; otherwise, startsWith check.
      if (item.exact && currentPath === item.path) {
        activePaths.push(currentKeyPath);
      } else if (!item.exact && currentPath.startsWith(item.path)) {
        activePaths.push(currentKeyPath);
      }
    }

    if (item.submenu && item.submenu.length > 0) {
      const subActivePaths = getActivePaths(item.submenu, currentPath, currentKeyPath);
      if (subActivePaths.length > 0) {
        activePaths.push(currentKeyPath);
        activePaths = [...activePaths, ...subActivePaths];
      }
    }
  }

  return activePaths;
};

const MenuItem = ({ item, keyPath, depth, toggleDropdown, dropdownStates, location }) => {
  const hasSubmenu = item.submenu && item.submenu.length > 0;
  const isOpen = dropdownStates[keyPath] || false;

  const isActive = useMemo(() => checkItemActive(item, location.pathname), [item, location.pathname]);

  const handleClick = (e) => {
    if (hasSubmenu) {
      e.preventDefault();
      toggleDropdown(keyPath);
    }
  };

  return (
    <li className="flex w-full flex-col">
      <NavLink
        to={hasSubmenu ? "/" : item.path || "/"}
        onClick={handleClick}
        className={({ isActive: isNavActive }) =>
          `flex items-center transition-all duration-300 ${isActive || isNavActive ? "" : "text-gray-700 hover:text-brand-primary"
          }`
        }
      >
        <div
          className={`flex w-full cursor-pointer items-center justify-between transition-all duration-300 my-[2px] ${isActive
            ? "border-l-8 border-solid border-brand-primary bg-[#CDF2CC]"
            : "hover:bg-[#CDF2CC]"
            }`}
          style={{
            padding: "0.5rem",
            paddingLeft: depth === 0 ? "0.5rem" : `${depth * 1.5}rem`,
          }}
        >
          <div className="flex items-center space-x-2">
            {item.icon}
            <span>{item.label}</span>
          </div>
          {hasSubmenu && (isOpen ? <AiFillCaretUp /> : <AiFillCaretDown />)}
        </div>
      </NavLink>

      {hasSubmenu && isOpen && (
        <ul className="space-y-2 transition duration-500 ease-in-out">
          {item.submenu.map((subItem, subIndex) => (
            <MenuItem
              key={subIndex}
              item={subItem}
              keyPath={`${keyPath}-${subIndex}`}
              depth={depth + 1}
              toggleDropdown={toggleDropdown}
              dropdownStates={dropdownStates}
              location={location}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const AdminSidebar = () => {
  const location = useLocation();
  const [dropdownStates, setDropdownStates] = useState({});
  const { logout } = useAuth();

  // Initialize dropdown states based on current path
  useEffect(() => {
    const activePaths = getActivePaths(menuItems, location.pathname);
    const newDropdownStates = {};

    // Set active paths to open
    activePaths.forEach((path) => {
      newDropdownStates[path] = true;
    });

    setDropdownStates(newDropdownStates);
  }, [location.pathname]);

  const toggleDropdown = (keyPath) => {
    setDropdownStates((prev) => {
      const newState = { ...prev };
      const pathSegments = keyPath.split("-");

      // If closing a submenu, close all its children
      if (newState[keyPath]) {
        Object.keys(newState).forEach((key) => {
          if (key.startsWith(keyPath + "-")) {
            newState[key] = false;
          }
        });
      } else {
        // If opening a submenu, close siblings at the same level
        if (pathSegments.length > 1) {
          const parentPath = pathSegments.slice(0, -1).join("-");
          Object.keys(newState).forEach((key) => {
            if (key.startsWith(parentPath + "-") && key !== keyPath && !key.startsWith(keyPath + "-")) {
              newState[key] = false;
            }
          });
        } else {
          Object.keys(newState).forEach((key) => {
            if (key.indexOf("-") === -1 && key !== keyPath) {
              newState[key] = false;
            }
          });
        }
      }
      // Toggle the current item
      newState[keyPath] = !newState[keyPath];
      return newState;
    });
  };

  return (
    <div className="relative flex h-full flex-col border-r border-gray-200 bg-white">
      <div className="my-6 flex w-full items-center justify-center">
        <img src="/images/logo/navlogo.png" alt="Logo" className="w-5/6" />
      </div>
      <div className="flex w-full flex-grow flex-col items-start overflow-x-auto">
        <ul className="w-full space-y-4 text-[15px] font-semibold">
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              item={item}
              keyPath={`${index}`}
              depth={0}
              toggleDropdown={toggleDropdown}
              dropdownStates={dropdownStates}
              location={location}
            />
          ))}
        </ul>
        <div className="mt-2 px-2 py-2">
          <NavLink
            onClick={logout}
            to="/"
            className="flex w-full items-center space-x-2 font-semibold text-brand-text-light hover:text-red-700"
          >
            <IoIosLogOut className="text-xl" />
            <span>Logout</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
